import { CrossButton } from 'components';
import React, { useContext } from 'react'
import './editTrip.css'
import { utils } from 'helper';
import { UserContext } from 'context';

const EditTripOffCanvas = (props) => {
  let { isOpen, onClose, tripDetais, setShowEditTrip=()=>{}, editLrWithParty=()=>{},deleteLr=()=>{},editLrInTrip=()=>{}} = props;

  const { masterData } = useContext(UserContext)
  const { branch_id, dispatch_date, due_date, end_date, vehicle_id, lorry_type_id, vehicle_type_id, vehicle_ownership, supplier_id, driver_id, route_name, start_kms, end_kms, trip_status, to_location } = tripDetais;

  const lr_list = tripDetais.to_location.reduce((acc, loc) => {
    if (Array.isArray(loc.lr_list)) {
      acc.push(...loc.lr_list);
    }
    return acc;
  }, []);

  return (
    <>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">Edit Trip</h5>
        <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
          <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black" />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className='__edtTrip_bg'>
          {dispatch_date && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>Trip Start Date & Time</span>
              <p>{dispatch_date && utils.formatDateMonth(dispatch_date)} | {dispatch_date && utils.formatTime(dispatch_date)}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Trip_start" })) }}>Edit</button>
          </div>}

          {due_date && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>Trip Due Date & Time</span>
              <p>{due_date && utils.formatDateMonth(due_date)} | {due_date && utils.formatTime(due_date)}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Trip_due" })) }}>Edit</button>
          </div>}

          {end_date && <div className='__orgBxs'>
            <div className='__orDate_tm' >
              <span>Trip End Date & Time</span>
              <p>{end_date && utils.formatDateMonth(end_date)} | {end_date && utils.formatTime(end_date)}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Trip_end" })) }}>Edit</button>
          </div>}

          {(vehicle_id?.vehicle_no && vehicle_ownership) && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>Vehicle Detail</span>
              <p>{vehicle_id?.vehicle_no && vehicle_id?.vehicle_no} | {masterData?.vehicle_ownership[vehicle_ownership]}</p>
            </div>
            <button className='__edtBtn'>Not Editable</button>
          </div>}

          {(lorry_type_id?.lorry_type && vehicle_type_id?.name) && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>VEHICLE TYPE</span>
              <p>{lorry_type_id?.lorry_type} | {vehicle_type_id?.name}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "vehicle_type" })) }}>Change</button>
          </div>}

          {(vehicle_id?.manage_trip_kms == 1 && (trip_status == 2 || trip_status == 4)) && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>Start Kms</span>
              <p>{start_kms}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Start_km" })) }}>Change</button>
          </div>}
          {(vehicle_id?.manage_trip_kms == 1 && trip_status == 4) && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>End Kms</span>
              <p>{end_kms}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "End_km" })) }}>Change</button>
          </div>}

          {supplier_id?.name && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>Supplier Details</span>
              <p>{supplier_id?.name || ""}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Trip_Supplier" })) }}>Change</button>
          </div>}

          {(vehicle_id?.vehicle_ownership == 2 && branch_id?.market_drive_on_dispatch?.view == 1) && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>MARKET DRIVER Details</span>
              <p>{driver_id?.name ? driver_id?.name : ""}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Market_driver" })) }}>Change</button>
          </div>}

          {vehicle_id?.vehicle_ownership != 2 && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>OWN DRIVER Details</span>
              <p>{driver_id?.name ? driver_id?.name : ""}</p>
            </div>
            <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Own_driver" })) }}>Change</button>
          </div>}

          {route_name && <div className='__orgBxs'>
            <div className='__orDate_tm'>
              <span>ROUTE</span>
              <p>{route_name}</p>
            </div>
            {/* <button className='__edtBtn' onClick={() => { setShowEditTrip((pre) => ({ ...pre, isOpen: true, type: "Trip_route" })) }}>Update</button> */}
          </div>}

          <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 15px 10px 12px" }}>
            {/* <div className='edit_Load'> */}
            <span style={{ fontSize: "16px", fontWeight: 500 }}>Edit LR/ Loads</span>
            <button className='__edtBtn' style={{ fontSize: "16px", fontWeight: 500 }} onClick={() => {
                editLrWithParty()
            
            }}>Add Loads</button>
            {/* </div> */}
          </div>



          {lr_list?.map((lr, index) => <div className="trip-card" key={index}>
            <div className="card-header">
              <h2 className="company-name">{lr?.consignor_id?.name || ""}</h2>
              <span className="trip-number">{lr?.lr_number ? `#${lr?.lr_number}` : ""} &gt;</span>
            </div>

            <div className="date">12/5/24</div>
            <div className="route-section" style={{ marginTop: "10px" }}>
              <span className="city">{lr?.from_location || ""}</span>

              <div >
                <svg xmlns="http://www.w3.org/2000/svg" width="136" height="29" viewBox="0 0 136 29" fill="none">
                  <path d="M0 15L51 15" stroke="#DFE8FF" />
                  <path d="M85 15L136 15" stroke="#DFE8FF" />
                  <circle cx="67.5" cy="14.5" r="14.5" fill="#DFE8FF" />
                  <path d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z" fill="#1450EC" />
                </svg>
              </div>

              <span className="city">{lr?.to_location || ""}</span>
            </div>


            <div className="action-buttons">
              <button className="action-btn edit-btn" onClick={()=>editLrInTrip(lr)}>Edit</button>
              <button className="action-btn remove-btn" onClick={()=>deleteLr(lr)}>Remove</button>
            </div>

          </div>)}
        </div>
      </div>

      <div className='offcanvas-footer'>
        <button className='_addComm_btn _sameWid' onClick={onClose}>Save</button>
        <button className='_cancel_btn _sameWid' onClick={onClose}>Cancel</button>
      </div>



    </>
  )
}

export default EditTripOffCanvas